<!--
  Root template of the ProvisionAgent OBC. Branches exclusively by view mode — the exact shape
  of bm-billing-area-object.component.html (PAT §L.2).
  The `initialized && dto` guard is mandatory (rule G3.1): no dto exists before that.
  `handleNavigationItems($event)` passes the Base component's navItems through to the frame's
  object navigation.
-->
@if (!initialized && loadError) {

    <!--
      DER FEHLSCHLAG DES OBJEKTLADENS, sichtbar gemacht.
      Ohne diesen Zweig rendert die Wächterbedingung unten bei einem fehlgeschlagenen Laden GAR
      NICHTS — `postRefreshObjectError` setzt `dto = null` UND `initialized = false`. Gemessen mit
      der Id 9000003052 (ein am.Agent-Stammsatz, kein Provisionskonto): die ganze Objektseite blieb
      leer, und eine leere Seite ist von einem gültigen leeren Ergebnis nicht zu unterscheiden.
      Die Basisklasse zeigt zwar eine Kurzmeldung, aber die verschwindet, nennt keine Id und ist auf
      einem Bildschirmfoto nicht mehr da.
    -->
    <div class="surface-card border-round-lg p-5 mt-4 flex flex-column align-items-center gap-3 text-center">

        <i class="fa-solid fa-circle-exclamation text-4xl text-red-500"></i>

        <span class="text-lg font-semibold">{{ loadError }}</span>

        @if (loadErrorHint) {
            <span class="text-color-secondary" style="max-width: 44rem">{{ loadErrorHint }}</span>
        }

        <div class="flex flex-wrap justify-content-center gap-2">
            <p-tag [value]="'Angefragte Id ' + objectIdentifier?.objectId"
                   icon="fa-solid fa-hashtag"
                   severity="secondary">
            </p-tag>
            <p-tag [value]="objectIdentifier?.objectType"
                   icon="fa-solid fa-cube"
                   severity="secondary">
            </p-tag>
            @if (loadErrorStatus) {
                <p-tag [value]="'HTTP ' + loadErrorStatus"
                       icon="fa-solid fa-triangle-exclamation"
                       severity="danger">
                </p-tag>
            }
        </div>

    </div>

}

@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <cp-provision-agent-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-agent-side>

    } @else {

        <cp-provision-agent-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-agent-full>

    }

}
